export default __webpack_public_path__ + "static/media/Ravensilk Leggings.00deb402.jpg";